import type { ApiResponse } from '../types';
import routes from '@/config/routes';
import { v3Get } from '@/api/axios.instance.V3';

const getCountryList = (): ApiResponse => v3Get(routes.backendUrl.vocab.getCountryList);
const getCountryById = (id: number): ApiResponse => v3Get(`${routes.backendUrl.vocab.getCountry}/${id}`);
const getProvinceList = (): ApiResponse => v3Get(routes.backendUrl.vocab.getProvinceList);
const getProvinceListByCountryId = (countryId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.vocab.getProvinceListByCountryId}${countryId}`);
const getLanguageList = (): ApiResponse => v3Get(routes.backendUrl.vocab.getLanguageList);
const getLanguageProficiencyList = (): ApiResponse => v3Get(routes.backendUrl.vocab.getLanguageProficiencyList);
const getLanguageProficiencyAreaList = (): ApiResponse => v3Get(routes.backendUrl.vocab.getLanguageProficiencyAreaList);
const getHardwareRequirementList = (): ApiResponse => v3Get(routes.backendUrl.vocab.getHardwareRequirementList);
const getHardwareRequirementOptionList = (): ApiResponse =>
  v3Get(routes.backendUrl.vocab.getHardwareRequirementOptionList);
const getCurrencyList = (): ApiResponse => v3Get(routes.backendUrl.vocab.getCurrencyList);
const getTypesList = (): ApiResponse => v3Get(routes.backendUrl.vocab.getTypesList);
const getTypeById = (id: string): ApiResponse => v3Get(`${routes.backendUrl.vocab.getTypeById}${id}`);
const getLengthsList = (): ApiResponse => v3Get(routes.backendUrl.vocab.getLengthList);
const getLengthById = (id: string): ApiResponse => v3Get(`${routes.backendUrl.vocab.getLengthById}${id}`);
const getCampaignStatusList = (): ApiResponse => v3Get(routes.backendUrl.vocab.getCampaignStatusList);
const getCourseDurationTypeList = (): ApiResponse => v3Get(routes.backendUrl.vocab.getCourseDurationTypeList);
const getCourseClassStatusList = (): ApiResponse => v3Get(routes.backendUrl.vocab.getCourseClassStatusList);
const getCourseClassTypeList = (): ApiResponse => v3Get(routes.backendUrl.vocab.getCourseClassTypeList);
const getCourseClassPlatformList = (): ApiResponse => v3Get(routes.backendUrl.vocab.getCourseClassPlaatformList);
const getVocabGigPriorityList = (): ApiResponse => v3Get(routes.backendUrl.vocab.getGigPriorityList);
export const vocabApi = {
  getCountryList,
  getCountryById,
  getProvinceList,
  getProvinceListByCountryId,
  getLanguageList,
  getLanguageProficiencyList,
  getLanguageProficiencyAreaList,
  getHardwareRequirementList,
  getHardwareRequirementOptionList,
  getCurrencyList,
  getTypesList,
  getTypeById,
  getLengthsList,
  getLengthById,
  getCampaignStatusList,
  getCourseDurationTypeList,
  getCourseClassStatusList,
  getCourseClassTypeList,
  getCourseClassPlatformList,
  getVocabGigPriorityList,
};
